import { combineReducers } from 'redux'
import client from './client'
import lineMessage from './lineMessage'
import reportSummary from './reportSummary'
import cvSummary from './cvSummary'
import sessions from './sessions'
import shops from './shops'
import shop from './shop'
import incentiveList from './incentiveList'
import crmScoring from './crmScoring'

const reducers = {
  lineMessage,
  reportSummary,
  cvSummary,
  sessions,
  client,
  shops,
  shop,
  incentiveList,
  crmScoring,
}

export type Reducers = typeof reducers
export type State = { [P in keyof Reducers]: ReturnType<Reducers[P]> }
export default combineReducers<State>(reducers)
